/**
 * Created by vaibhav on 1/4/18
 */
import React from 'react'
import PropTypes from 'prop-types'
import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'

const Offerings = ({ gridItems }) => (
    <div className="columns is-multiline">
        {gridItems.map(item => (
            <div key={item.image} className="column is-6">

                    <div dangerouslySetInnerHTML={{ __html: remark().use(recommended).use(remarkHtml).processSync(item.text).toString()}}/>

            </div>
        ))}
    </div>
);

Offerings.propTypes = {
    gridItems: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            text: PropTypes.string,
        })
    ),
};

export default Offerings;



// WEBPACK FOOTER //
// ./src/components/Offerings/index.js